
/* eslint-disable no-unused-vars */
import Promise from "plugins/bluebird/index"
/* eslint-enable no-unused-vars */
import {
  q_ajax_3,
  ERROR_HANDLER_ACTIONS as AJAX_ERROR_HANDLER_ACTIONS,
} from "app/utils/q_ajax/q_ajax_3"


interface Input {
  email: string,
  full_name: string,
  image: string,
  id_token: string,
}

/* eslint-disable no-unused-vars */
enum ResultTypeEnums {
  SUCCESS = "SUCCESS",
  INVALID = "INVALID",
  CONFLICT = "CONFLICT",
  UNAUTHORIZED = "UNAUTHORIZED",
}
/* eslint-enable no-unused-vars */

interface PromiseResolvePayload {
  result_type: ResultTypeEnums,
}

const create = ({email, full_name, image, id_token}: Input): Promise<PromiseResolvePayload> => {
  return Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    return q_ajax_3(
      {
        url:      Routes.create_with_google_api_web_app_users_path(),
        method:   "POST",
        dataType: "json",
        data:     {
          email:      email,
          full_name:  full_name,
          image:      image,
          id_token:   id_token,
        },
      },
      {
        custom_error_handler: ({http_status_code}) => {
          if (http_status_code === 409) {
            return AJAX_ERROR_HANDLER_ACTIONS.STOP_RETRY
          }

          return AJAX_ERROR_HANDLER_ACTIONS.CONTINUE_RETRY
        },
      },
    )
  })
  .then(() => {
    return ({result_type: ResultTypeEnums.SUCCESS})
  })
  .catch((reason_or_error) => {
    if (reason_or_error instanceof Error) {
      throw reason_or_error
    }

    const { response } = reason_or_error
    switch (response.status) {
      case 409: {
        return ({result_type: ResultTypeEnums.CONFLICT})
      }
      case 401: {
        return ({result_type: ResultTypeEnums.UNAUTHORIZED})
      }
      default:
        return ({result_type: ResultTypeEnums.INVALID})
    }
  })
}

export {
  create as default,
  create,
  ResultTypeEnums,
}
